<template>
  <div class="playback-controls" :class="{ compact }" aria-label="Playback controls">
    <button
      v-if="stateAware"
      type="button"
      class="playback-button"
      :title="playbackAction.label"
      :aria-label="playbackAction.label"
      @click="$emit(playbackAction.event)"
    >
      <span>{{ playbackAction.icon }}</span>
      <span class="playback-label">{{ playbackAction.label }}</span>
    </button>
    <template v-else>
      <button type="button" class="playback-button" @click="$emit('play')">
        <span>▶️</span>
        <span class="playback-label">Play</span>
      </button>
      <button type="button" class="playback-button" @click="$emit('pause')">
        <span>⏸</span>
        <span class="playback-label">Pause</span>
      </button>
    </template>
    <button
      type="button"
      class="playback-button"
      :class="{ loading: isNextLoading }"
      :disabled="isNextLoading"
      @click="$emit('next')"
    >
      <span>⏭</span>
      <span class="playback-label">Next</span>
    </button>
  </div>
</template>

<script>
import { getPlaybackAction } from '../utils/hostPlaybackState.mjs'

export default {
  name: 'PlaybackControls',
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    isNextLoading: {
      type: Boolean,
      default: false
    },
    stateAware: {
      type: Boolean,
      default: false
    },
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  emits: ['play', 'pause', 'next'],
  computed: {
    playbackAction() {
      return getPlaybackAction(this.isPlaying)
    }
  }
}
</script>

<style scoped>
.playback-controls {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.playback-button {
  width: 120px;
  min-height: 58px;
  padding: 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font: inherit;
  font-size: 20px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
}

.playback-button:hover {
  background: rgba(255, 165, 0, 0.2);
  transform: translateY(-1px);
}

.playback-button:active {
  transform: translateY(0);
}

.playback-button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.playback-label {
  color: white;
  font-size: 0.75rem;
  font-weight: 500;
}

.compact {
  max-width: none;
  margin: 0;
  padding: 0;
  gap: 0.35rem;
}

.compact .playback-button {
  width: 44px;
  min-height: 44px;
  padding: 0.35rem;
  font-size: 0.95rem;
}

.compact .playback-label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
